import { render, staticRenderFns } from "./OrderShowConfigurationCard.vue?vue&type=template&id=400e3c67"
import script from "./OrderShowConfigurationCard.vue?vue&type=script&lang=ts"
export * from "./OrderShowConfigurationCard.vue?vue&type=script&lang=ts"
import style0 from "./OrderShowConfigurationCard.vue?vue&type=style&index=0&id=400e3c67&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports